import * as React from "react";
import { SVGProps } from "react";

const SvgEightClubs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 287 402"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M275.8.1H11.1S0 .4 0 15.1v371.7c0 14.7 11.1 15 11.1 15h264.6s11.1-.3 11.1-15V15.1c.1-14.7-11-15-11-15Z"
      fill="#fff"
    />
    <mask
      id="eight-clubs_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={216}
      width={287}
      height={186}
    >
      <path
        d="M169.2 216.9c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15v-170c-39.2 0-78.5.1-117.7.1Z"
        fill="url(#eight-clubs_svg__a)"
      />
    </mask>
    <g mask="url(#eight-clubs_svg__b)">
      <path
        d="M169.2 216.9c-56.4 0-112.8 0-169.2.1v169.8c0 14.7 11.1 15 11.1 15h264.7s11.1-.3 11.1-15v-170c-39.2 0-78.5.1-117.7.1Z"
        fill="url(#eight-clubs_svg__c)"
      />
    </g>
    <mask
      id="eight-clubs_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={287}
      height={201}
    >
      <path
        d="M0 200.5h72.4c69.6 0 139.2 0 208.7.1h5.7V15.1c0-14.7-11.1-15-11.1-15H11.1S0 .4 0 15.1v185.4Z"
        fill="url(#eight-clubs_svg__d)"
      />
    </mask>
    <g mask="url(#eight-clubs_svg__e)">
      <path
        d="M0 200.5h72.4c69.6 0 139.2 0 208.7.1h5.7V15.1c0-14.7-11.1-15-11.1-15H11.1S0 .4 0 15.1v185.4Z"
        fill="url(#eight-clubs_svg__f)"
      />
    </g>
    <mask
      id="eight-clubs_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={282}
      height={402}
    >
      <path
        d="M286.3 15.1v371c0 14.7-11.1 15-11.1 15H10.3s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15.1c0-14.7-11.1-15-11.1-15h-.6c.1 0 11.2.3 11.2 15Z"
        fill="url(#eight-clubs_svg__g)"
      />
    </mask>
    <g mask="url(#eight-clubs_svg__h)">
      <path
        d="M286.3 15.1v371c0 14.7-11.1 15-11.1 15H10.3s-2.4-.1-5-1.6c2.9 2.1 5.8 2.2 5.8 2.2h264.6s11.1-.3 11.1-15V15.1c0-14.7-11.1-15-11.1-15h-.6c.1 0 11.2.3 11.2 15Z"
        fill="url(#eight-clubs_svg__i)"
      />
    </g>
    <mask
      id="eight-clubs_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={282}
      height={402}
    >
      <path
        d="M.6 386.8v-371C.6 1.1 11.7.8 11.7.8h265s2.4.1 5 1.6C278.8.3 275.9.2 275.9.2H11.1S0 .5 0 15.2v371.7c0 14.7 11.1 15 11.1 15h.6c0-.2-11.1-.5-11.1-15.1Z"
        fill="url(#eight-clubs_svg__j)"
      />
    </mask>
    <g mask="url(#eight-clubs_svg__k)">
      <path
        d="M.6 386.8v-371C.6 1.1 11.7.8 11.7.8h265s2.4.1 5 1.6C278.8.3 275.9.2 275.9.2H11.1S0 .5 0 15.2v371.7c0 14.7 11.1 15 11.1 15h.6c0-.2-11.1-.5-11.1-15.1Z"
        fill="url(#eight-clubs_svg__l)"
      />
      <mask
        id="eight-clubs_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={29}
        width={1}
        height={347}
      >
        <path
          d="M0 29.1v346.3l.6-2.1V35.4L0 29.1Z"
          fill="url(#eight-clubs_svg__m)"
        />
      </mask>
      <g mask="url(#eight-clubs_svg__n)">
        <path
          d="M0 29.1v346.3l.6-2.1V35.4L0 29.1Z"
          fill="url(#eight-clubs_svg__o)"
        />
      </g>
    </g>
    <path
      d="M21.9 79.9c-.6 7.5-4.8 12.7-4.8 12.7h9.6s-4.2-5.2-4.8-12.7Z"
      fill="#000"
    />
    <path
      d="M28.9 71.5c-1 0-1.9.2-2.7.5l-.1-.1c1.7-1.3 2.8-3.3 2.8-5.6 0-3.9-3.1-7-7-7s-7 3.1-7 7c0 2.4 1.2 4.6 3.1 5.8-.9-.5-2-.7-3.1-.7-3.9 0-7 3.1-7 7s3.1 7 7 7c3.8 0 6.8-3 7-6.7.2 3.7 3.2 6.7 7 6.7 3.9 0 7-3.1 7-7 0-3.8-3.1-6.9-7-6.9ZM27.6 33.7l.1.3c1.9.7 3.4 1.8 4.3 3.3 1 1.4 1.5 3.1 1.5 5.2 0 2-.5 3.7-1.4 5.2-.9 1.5-2.3 2.7-4.1 3.5-1.8.8-3.9 1.2-6.3 1.2-2.2 0-4.2-.4-5.9-1.1-1.7-.8-3-1.9-4-3.3-.9-1.4-1.4-3.1-1.4-5.1 0-1.5.3-2.7.8-3.8.5-1.1 1.2-2 2-2.7.8-.7 1.9-1.3 3.1-1.9l-.1-.3c-3.6-1.6-5.5-4.3-5.5-8.1 0-1.7.5-3.3 1.4-4.7 1-1.4 2.3-2.4 4.1-3.2 1.8-.8 3.7-1.2 5.9-1.2 2.4 0 4.5.3 6.1 1 1.7.7 2.9 1.7 3.7 3 .8 1.3 1.3 2.8 1.3 4.7 0 1.9-.5 3.5-1.4 4.8-.9 1.3-2.3 2.4-4.2 3.2Zm-12.4 8.8c0 1.1.1 2.1.4 3.1.3 1 .7 1.8 1.2 2.5s1.3 1.2 2.1 1.6c.9.4 1.9.6 3.1.6 1.4 0 2.6-.3 3.6-.8 1-.6 1.7-1.4 2.3-2.5.5-1.1.8-2.4.8-4s-.3-3-.8-4.2c-.6-1.2-1.3-2.1-2.4-2.7-1-.6-2.2-.9-3.5-.9-1.3 0-2.3.2-3.2.6-.9.4-1.5.9-2.1 1.6-.5.7-.9 1.4-1.1 2.3-.3.8-.4 1.8-.4 2.8Zm.2-16.7c0 1 .1 1.9.4 2.8.2.9.6 1.6 1.1 2.3.5.6 1.2 1.2 2 1.5.8.4 1.9.6 3.1.6 1.4 0 2.6-.3 3.5-.8 1-.5 1.7-1.4 2.1-2.4.5-1.1.7-2.3.7-3.7 0-1.5-.3-2.8-.8-3.9s-1.3-1.8-2.3-2.3c-1-.5-2.1-.8-3.3-.8-2.1 0-3.8.6-4.9 1.7-1 1.3-1.6 2.9-1.6 5ZM264.4 320.9c.6-7.5 4.8-12.7 4.8-12.7h-9.6s4.2 5.2 4.8 12.7Z"
      fill="#000"
    />
    <path
      d="M257.4 329.3c1 0 1.9-.2 2.7-.5l.1.1c-1.7 1.3-2.8 3.3-2.8 5.6 0 3.9 3.1 7 7 7s7-3.1 7-7c0-2.4-1.2-4.6-3.1-5.8.9.5 2 .7 3.1.7 3.9 0 7-3.1 7-7s-3.1-7-7-7c-3.8 0-6.8 3-7 6.7-.2-3.7-3.2-6.7-7-6.7-3.9 0-7 3.1-7 7 0 3.8 3.1 6.9 7 6.9ZM258.7 367l-.1-.3c-1.9-.7-3.4-1.8-4.3-3.3-1-1.4-1.5-3.1-1.5-5.2 0-2 .5-3.7 1.4-5.2.9-1.5 2.3-2.7 4.1-3.5 1.8-.8 3.9-1.2 6.3-1.2 2.2 0 4.2.4 5.9 1.1 1.7.8 3 1.9 4 3.3.9 1.4 1.4 3.1 1.4 5.1 0 1.5-.3 2.7-.8 3.8-.5 1.1-1.2 2-2 2.7-.8.7-1.9 1.3-3.1 1.9l.1.3c3.6 1.6 5.5 4.3 5.5 8.1 0 1.7-.5 3.3-1.4 4.7-1 1.4-2.3 2.4-4.1 3.2-1.8.8-3.7 1.2-5.9 1.2-2.4 0-4.5-.3-6.1-1-1.7-.7-2.9-1.7-3.7-3-.8-1.3-1.3-2.8-1.3-4.7 0-1.9.5-3.5 1.4-4.8.9-1.2 2.3-2.3 4.2-3.2Zm12.4-8.7c0-1.1-.1-2.1-.4-3.1-.3-1-.7-1.8-1.2-2.5s-1.3-1.2-2.1-1.6c-.9-.4-1.9-.6-3.1-.6-1.4 0-2.6.3-3.6.8-1 .6-1.7 1.4-2.3 2.5-.5 1.1-.8 2.4-.8 4s.3 3 .8 4.2c.6 1.2 1.3 2.1 2.4 2.7 1 .6 2.2.9 3.5.9 1.3 0 2.3-.2 3.2-.6.9-.4 1.5-.9 2.1-1.6.5-.7.9-1.4 1.1-2.3.3-.8.4-1.8.4-2.8Zm-.2 16.6c0-1-.1-1.9-.4-2.8-.2-.9-.6-1.6-1.1-2.3-.5-.6-1.2-1.2-2-1.5-.8-.4-1.9-.6-3.1-.6-1.4 0-2.6.3-3.5.8-1 .5-1.7 1.4-2.1 2.4-.5 1.1-.7 2.3-.7 3.7 0 1.5.3 2.8.8 3.9s1.3 1.8 2.3 2.3c1 .5 2.1.8 3.3.8 2.1 0 3.8-.6 4.9-1.7 1-1.2 1.6-2.8 1.6-5ZM143.5 149.2c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.4-10.3-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M157.4 132.5c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.5 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.3-13.9-13.9-13.9ZM143.5 259.1c1.2-14.8 9.6-25.2 9.6-25.2h-19.2s8.3 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M129.6 275.9c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.5-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.2 13.9 13.9 13.9ZM196.5 88.2c-1.2 14.8-9.6 25.2-9.6 25.2h19.2c-.1 0-8.4-10.3-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M210.4 71.5c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.5 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.3-13.9-13.9-13.9ZM196.5 313.6c1.2-14.8 9.6-25.2 9.6-25.2h-19.2s8.3 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M182.6 330.4c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.2 13.9 13.9 13.9ZM196.5 208.7c-1.2 14.8-9.6 25.2-9.6 25.2h19.2c-.1 0-8.4-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M210.4 191.9c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.5 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9 0-7.6-6.3-13.9-13.9-13.9ZM90.5 88.2c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.4-10.3-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M104.4 71.5c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.5 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9s-6.3-13.9-13.9-13.9ZM90.5 208.7c-1.2 14.8-9.6 25.2-9.6 25.2h19.2s-8.4-10.4-9.6-25.2Z"
      fill="#000"
    />
    <path
      d="M104.4 191.9c-1.9 0-3.7.4-5.4 1.1l-.1-.1c3.3-2.5 5.5-6.5 5.5-11.1 0-7.7-6.2-13.9-13.9-13.9s-13.9 6.2-13.9 13.9c0 4.8 2.5 9.1 6.2 11.6-1.9-.9-4-1.5-6.2-1.5-7.7 0-13.9 6.2-13.9 13.9s6.2 13.9 13.9 13.9c7.5 0 13.6-5.9 13.9-13.3.3 7.4 6.4 13.3 13.9 13.3 7.7 0 13.9-6.2 13.9-13.9 0-7.6-6.3-13.9-13.9-13.9ZM90.5 313.6c1.2-14.8 9.6-25.2 9.6-25.2H80.9s8.3 10.4 9.6 25.2Z"
      fill="#000"
    />
    <path
      d="M76.6 330.4c1.9 0 3.7-.4 5.4-1.1l.1.1c-3.3 2.5-5.5 6.6-5.5 11.1 0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-4.8-2.5-9.1-6.2-11.6 1.9.9 4 1.5 6.2 1.5 7.7 0 13.9-6.2 13.9-13.9s-6.2-13.9-13.9-13.9c-7.5 0-13.6 5.9-13.9 13.3-.3-7.4-6.4-13.3-13.9-13.3-7.7 0-13.9 6.2-13.9 13.9 0 7.6 6.2 13.9 13.9 13.9Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="eight-clubs_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.024 -136.86) scale(580.826)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(139.024 -136.86) scale(580.826)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.77 370.739) scale(416.199)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.77 370.739) scale(416.199)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.263 -.106) scale(462.125)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-12.263 -.106) scale(462.125)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.377 116.972) scale(393.607)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.377 116.972) scale(393.607)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 149.547 -.054) scale(462.075)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="eight-clubs_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 149.547 -.054) scale(462.075)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgEightClubs;
